import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Paper } from '@mui/material';
import { api } from '../api/base';
import { getUser } from 'api/users';
import { User } from 'typings/models';

interface LoginPageProps {
    setToken: (token: string) => void;
    setUser: (user: User | null) => void;
    onLogin: (role: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ setToken, setUser, onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            const response = await api.post('/auth/login', { username, password });
            const data = response.data;
            setToken(data.access_token);
            localStorage.setItem('token', data.access_token);
            const user = await getUser();
            if (user) {
                setUser(user);
                onLogin(user.role);
            }
        } catch (error) {
            console.error(error);
            setError('Login failed. Please check your credentials.');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <div style={{ textAlign: 'center', marginBottom: '20px', color: 'black' , marginTop: '10px'}}>
                <img src="https://courierapp-resouces.s3.us-east-1.amazonaws.com/images/logo.jpg" 
                alt="Logo" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
            <Paper elevation={3} style={{ padding: '20px', marginTop: '10px' }} >
                <Typography variant="h5" component="h1" gutterBottom align="center">
                    Registro
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Usuario"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        label="Contraseña"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && <Typography color="error">{error}</Typography>}
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Iniciar sesión
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default LoginPage;
